/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../HierarchicalFilterController',
	'underscore'
], function(BaseClass, _) {
	'use strict';

	var HierarchicalLocalFilterController = BaseClass.extend({
		// @overrides
		init: function(options) {
			HierarchicalLocalFilterController.inherited('init', this, arguments);

			this.id = _.uniqueId('HierarchicalLocalFilterController');
			this.itemContext = options.itemContext;
			this.commonView = options.commonView;
			this.viewConfig = {
				commonView: this.commonView,
				dashboardApi: this.dashboardApi
			};

			this.visualization = options.visualization;
			this.localFilters = this.visualization.getLocalFilters();

			// ignore the aggregation for hierarchical filter
			delete this.itemContext.aggregationType;
		},

		_initializeExtraData: function () {},

		_getInitialSelection: function(){
			const filter = this._getFilter();
			const filterValues = filter && filter.values;
			var initialSelection = _.map(filterValues, function(filterValue) {
				return filterValue.u;
			});
			return initialSelection;
		},

		_getFilter: function() {
			return _.find(this.localFilters.getFilterList(), filter => {
				return filter.columnId === this.itemContext.itemId;
			});
		},

		_getDialogCaption: function(){
			return this.itemContext.itemName;
		},
		/* returns the inverted state of the persisted filter item */
		_getSelectionIsInverted: function() {
			const filter = this._getFilter();
			return filter && filter.operator.indexOf('not') >= 0 ? true : false;
		},

		onDone: function() {
			const filterSpec = {
				command: 'replace',
				overrideHierarchyDefaultSelection: true,
				exclude: this.model.getInvert(),
				values: this.model.getSelectedMembers()
			};
			if (this.localFilters.filterExists(this.itemContext)) {
				this.localFilters.editFilter(this.itemContext, filterSpec);
			} else {
				this.localFilters.addFilter(this.itemContext, filterSpec);
			}
			if (!this.view.isCompact) {
				this.view.remove();
			}
			if(this.commonView.remove){
				this.commonView.remove();
			}
		},

		onClose: function(){
			HierarchicalLocalFilterController.inherited('onClose', this, arguments);
			if(this.commonView.remove){
				this.commonView.remove();
			}
		}
	});
	return HierarchicalLocalFilterController;
});
